const winWidth = window.innerWidth;

const fullSliders = Array.prototype.slice.call(document.querySelectorAll('.slider'));
fullSliders.forEach(slider => {

    if (document.querySelector('.slider') !== null) {
        const sliderID = slider.id;

        // Navigation style
        // const activeSlideSpan = document.querySelector('#' + sliderID + ' .active-slider');
        // const slideCountSpan = document.querySelector('#' + sliderID + ' .slide-count');
        const slidesInView = document.querySelector('#' + sliderID + ' .slides-in-view');

        const sliderContainer = document.querySelector('#' + sliderID + ' .slider-container');
        const slides = Array.prototype.slice.call(document.querySelectorAll('#' + sliderID + ' .slide'));
        const slideCount = slides.length;
        const prev = document.querySelector('#' + sliderID + ' .prev');
        const next = document.querySelector('#' + sliderID + ' .next');
        let count = 0;
        let containerWidth;
        let barValue = 100 / slideCount;

        // Set Visible slider width
        slidesInView.style.width = `${count * barValue + barValue}%`;

        // Set Container width
        containerWidth = sliderContainer.offsetWidth;
        // if (winWidth >= 1024) {
        //     containerWidth = sliderContainer.offsetWidth;
        // } else {
        //     containerWidth = winWidth;
        //     slider.style.width = `${winWidth}px`;
        // }

        // Set slider width
        sliderContainer.style.width = `${containerWidth * slideCount}px`;

        // Set slides width
        slides.forEach(slide => {
            if (winWidth >= 1024) {
                slide.style.width = `${containerWidth}px`;
            } else {
                slide.style.width = `${containerWidth}px`;
            }

        });

        // Check if animation is running
        let isAnimating = false;

        // Animate slider on arrow click
        next.addEventListener('click', function () {
            if (!isAnimating) {
                isAnimating = true;
                count++;

                sliderContainer.style.transform = `translate(-${count * containerWidth}px)`;

                if (count >= slideCount) {
                    sliderContainer.style.transform = 'translate(0px)';
                    count = 0;
                    slidesInView.style.width = '100%';
                }

                // Set value of navigation bar
                slidesInView.style.width = `${count * barValue + barValue}%`;
                isAnimating = false;
            }
        })

        prev.addEventListener('click', function () {
            if (!isAnimating) {
                isAnimating = true;
                count--;
                sliderContainer.style.transform = `translate(-${count * containerWidth}px)`;

                if (count < 1) {
                    count = 0;
                    sliderContainer.style.transform = 'translate(0px)';
                }
                // Set value of navigation bar
                slidesInView.style.width = `${count * barValue + barValue}%`;
                isAnimating = false;
            }
        })
    }
});


// WEBPACK FOOTER //
// ./scripts/util/quotes.js